import {
  Image
} from '@shopify/hydrogen';
import gifts from '../assets/image/gifts.svg';
import delivery from '../assets/image/delivery.svg';
import 'react-loading-skeleton/dist/skeleton.css';

export default function ProductDetailsNotFound({
  product
}) {
  const getIsb = ()=>{
    return product.store.options.find((option)=>option.name == 'isbn');
  }

  return (<>
      <article>
          <div></div>
          <div class="product-detail-wrapper">
              <div class="md:container md:mx-auto flex xs:flex-col xs:p-5">
                  <div class="md:hidden mt-5 mb-8 xs:hidden">
                      <h1 class="text-4xl font-bold text-black mb-4">
                        {product.title}
                      </h1>
                      <div class="text-sm font-medium mb-2 text-gray-900">Larousse</div>
                      <span></span>
                      <div class="flex justify-between md:block">
                          <div class="price-wrapper flex md:justify-start items-end md:pt-3 xs:border-t xs:flex-wrap">
                              <div class="md:hidden xs:visible xs:w-full xs:block xs:text-sm">Precio:</div>
                              <div class="mr-2 price-currency">MXN</div>
                              <div class="product-price product-top-price">{product?.priceRange?.maxVariantPrice}</div>
                          </div>
                          <div class="price-wrapper flex md:justify-start items-end md:pt-3 xs:border-t xs:flex-wrap">
                            Agotado
                          </div>
                      </div>
                  </div>
                  <div class="product-main-wrapper product-main-wrapper-not-found md:container md:mx-auto flex xs:grid xs:grid-cols-2 xs:gap-4 xs:my-8 pt-4 xs:pb-4 xs:pt-0 xs:mt-0 xs:mb-0 xs:border-0">
                      <div class="product-main-img md:w-3/12 md:p-5 xs:w-full">
                          <div class="relative">
                            <img 
                                id="gid://shopify/ProductImage/44091583070462" 
                                alt="" 
                                loading="lazy" 
                                fetchpriority="high" 
                                class="w-full mx-auto h-full md:h-auto object-cover object-center flex-shrink-0 md:flex-shrink-none snap-start md:col-span-2 cursor-pointer" 
                                src={product?.store.previewImageUrl}
                                width="761" 
                                height="1200"
                                decoding="async" 
                            />
                          </div>
                      </div>
                      <div class="md:w-5/12 md:p-5 xs:w-full">
                          <div class="md:block">
                              <p class="product-title text-2xl font-semibold text-black mb-4">{product.store.title}</p>
                              <h1 class="product-title text-2xl font-semibold text-black mb-4 special-tag">{product.store.title} - El Librero de Larousse</h1>
                              <div id="product-stars">
                                  {/* <div class="stars-container">
                                      &nbsp;<span class="calification-total">0</span>&nbsp;
                                      <span class="calification-total-label">(0 Calificaciones)</span>
                                  </div> */}
                              </div>
                              <div class="text-sm">
                                  <span class="font-medium">ISBN: </span>
                                  <span class="text-blue-55 font-medium">{getIsb()?.values?.[0] || 'N/A'}</span>
                              </div>
                              <div class="text-sm">
                                  <span class="font-medium"> Autor: </span>
                                  <a class="text-blue-55 underline font-medium" href={"/search?q="+product.autor}>{product.autor}</a>
                              </div>
                              <div class="text-sm">
                                  <span class="font-medium"> Idioma: </span>
                                  <span class="text-blue-55 font-medium">{product?.idioma_principal}</span>
                              </div>
                              <div class="price-wrapper flex md:justify-start items-end md:pt-3 xs:border-t xs:flex-wrap">
                                  <div class="md:hidden xs:visible xs:w-full xs:block xs:text-sm">Precio:</div>
                                  <div class="mr-2 price-currency">MXN</div>
                                  <div class="product-price product-top-price">{product?.store?.priceRange?.maxVariantPrice}.00</div>
                              </div>
                              <div class="price-wrapper flex md:justify-start items-end md:pt-3 xs:border-t xs:flex-wrap">
                                Agotado
                            </div>
                          </div>
                          <div class="tag-wrapper is-only-desktop">
                            {/* <div class="product-icon-details flex gap-4 my-4 xs:hidden">
                                <div class="product-icon-details-delivery flex justify-left items-center">
                                    <Image
                                        src={delivery}
                                        height={35}
                                        width={35}
                                        className="mr-2"
                                        alt="Gifts"
                                    />
                                    <span class="font-medium text-sm leading-tight">
                                        <div>Recíbelo en 8 días</div>
                                        </span>
                                    </div>
                                    <div class="flex justify-center items-center">
                                    <Image
                                        src={gifts}
                                        height={35}
                                        width={35}
                                        className="mr-2"
                                        alt="Gifts"
                                    />
                                    <span class="text-sm font-medium leading-tight">
                                        Regalos en todos tus pedidos</span>
                                    </div>
                            </div> */}
                              <div class="flex space-x-4"></div>
                          </div>
                      </div>
                  </div>   
                  <div class="tag-wrapper is-only-mobile">
                      <div class="product-icon-details flex gap-4 my-4 xs:hidden">
                          <div class="product-icon-details-delivery flex justify-left items-center">
                                <Image
                                    src={delivery}
                                    height={35}
                                    width={35}
                                    className="mr-2"
                                    alt="Gifts"
                                />
                              <span class="font-medium text-sm leading-tight">Recíbelo en 7 días</span>
                          </div>
                          <div class="flex justify-center items-center">
                                <Image
                                    src={gifts}
                                    height={35}
                                    width={35}
                                    className="mr-2"
                                    alt="Gifts"
                                />
                              <span class="text-sm font-medium leading-tight">Regalos en todos tus pedidos</span>
                          </div>
                      </div>
                      <div class="xs:hidden md:visible">
                          <div class="pt-0"></div>
                          <div class="pt-4">
                              <div class="fixed-mobile-btn pb-5 flex gap-5 xs:px-3 items-center"></div>
                          </div>
                      </div>
                      <div class="flex space-x-4"></div>
                  </div>
                  <div class="xs:visible md:hidden">
                      <div class="text-center"></div>
                      <div class="w-full">
                          <div class="hidden product-notice text-2xl bg-red-40 text-white font-bold p-3 rounded-full text-center">
                              ¡Quedan pocas unidades!
                          </div>
                            {/* <div class="product-shipping-info grid gap-2 grid-cols-2">
                                <div class="flex justify-center items-center">
                                    <Image
                                        src={delivery}
                                        height={35}
                                        width={35}
                                        className="mr-2"
                                        alt="Gifts"
                                    />
                                    <label class="font-semibold">
                                        <div>Recíbelo en 8 días</div>
                                    </label>
                                </div>
                                <div class="flex justify-center items-center">
                                <Image
                                    src={gifts}
                                    height={35}
                                    width={35}
                                    className="mr-2"
                                    alt="Gifts"
                                />
                                <label class="font-semibold xs:font-medium">Regalos en todos tus pedidos</label>
                                </div>
                            </div> */}
                      </div>
                  </div>
              </div>
          </div>
          <section class="product-description-wrapper md:mx-auto py-10 xs:pt-5 xs:mb-5">
              <div class="container">
                  <h2 class="section-title mb-4">Descripción</h2>
                  <div class="product-description xs:px-4">
                    {product?.store.descriptionHtml}
                  </div>
              </div>
          </section>
      </article>



  </>)
}